import React, { Component, PropTypes } from 'react';
import styles from './Header.scss';
import HeaderFirstLvl from './HeaderFirstLvl';
import HeaderSecondLvl from './HeaderSecondLvl';

export default class Header extends Component {
  render() {
    return (
      <div className={styles.headerContainer}>
        <HeaderFirstLvl />
        <HeaderSecondLvl {...this.props} />
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Header/Header.jsx
 **/